import React from 'react'
import Style from './Hero.css'
import hero1 from '../../assets/Hero-Student-1.jpg'
import hero2 from '../../assets/Hero-Student-2.jpg'
import hero3 from '../../assets/Hero-Student-3.jpg'
import hero4 from '../../assets/Hero-Student-4.jpg'
import hero5 from '../../assets/Hero-Student-5.jpg'
import Button from '../Button/Button'

const Hero = ({ banner, heroImage }) => {
  return (
    <section>
      <div className="hero-wrapper">
        <div className="container overflow-hidden">
          <div>
            <div className="flex justify-between items-start top-wrap">
              <div className="skewedShadow1">
                <div className="z-1">
                  <img width="197" src={hero1} />
                </div>
              </div>

              <div className="skewedShadow2">
                <div>
                  <img width="181" src={hero2} />
                </div>
              </div>
              <div className="skewedShadow3">
                <div>
                  <img width="180" src={hero3} />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center banner">
            <div className="goals xtra-condensed">OUR GOALS</div>
            <div className="future xtra-condensed">OUR FUTURE</div>
          </div>

          <div>
            <div className="flex justify-center banner2 pt-6 relative">
              <div className="text-white">
                <h1 className="font-black text-5xl xtra-condensed">OUR HONORS COLLEGE</h1>
                <p className="max-w-[474px] pt-3 pl-6">
                  A better tomorrow starts together today at the
                </p>
                <p className="max-w-[474px] pl-6">W.A. Franke Honors College.</p>
              </div>
            </div>
          </div>

          <div>
            <div className="flex justify-between bottom-row items-start">
              <div className="skewedShadow4">
                <div>
                  <img width="188" src={hero4} />
                </div>
              </div>

              <div className="banner2-button-wrap text-white flex justify-end mt-6">
                <Button
                  linkId="get-started"
                  className="border-white condensed"
                  link="https://frankehonors.arizona.edu/admissions/application-process"
                >
                  Get Started
                </Button>
              </div>

              <div className="skewedShadow5">
                <div>
                  <img width="259" src={hero5} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
